import styled from "styled-components";

import { PrimaryText } from "@/shared/ui/Typography";

export const StyledMMLValue = styled(PrimaryText)`
    color: ${(props) => props.theme.lightBlue} !important;
`;
